// collection vehicle entrance
document.querySelectorAll(".section-container-entrance").forEach((slider) => {

  const desk = Number(slider.dataset.slideDesk);
  const pad = Number(slider.dataset.slidePad);
  const phone = Number(slider.dataset.slidePhone);

  const parent = slider.closest(".economy_vehicle_entrance");

  new Swiper(slider, {
    slidesPerView: desk,
    spaceBetween: 30,

    navigation: {
      nextEl: parent.querySelector(".entrance-button-next-btn"),
      prevEl: parent.querySelector(".entrance-button-prev-btn"),
    },

    breakpoints: {
      320: {
        slidesPerView: phone,
        spaceBetween: 20,
      },

      540: {
        slidesPerView: phone,
        spaceBetween: 20,
      },

      768: {
        slidesPerView: pad,
        spaceBetween: 20,
      },

      1024: {
        slidesPerView: desk,
        spaceBetween: 20,
      },

      1250: {
        slidesPerView: desk,
        spaceBetween: 30,
      },
    },
  });

});
document.addEventListener("DOMContentLoaded", function () {
  // product variant colors
  var swiper = new Swiper(".products_switch__variant_color", {
    spaceBetween: 30,
    navigation: {
      nextEl: ".switch-variant-next",
      prevEl: ".switch-variant-prev",
    },
    slidesPerView: 1,
    breakpoints: {
      1920: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1028: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2.5,
      },
      480: {
        slidesPerView: 1,
      },
    },
  });

  $(".products-item-option_title").click(function () {
    let index = $(this).index();
    let lIndex = -1;
    if (index != lIndex) {
      $(".products-item-option_title").removeClass(
        "products-option-title-active"
      );
      $(this).addClass("products-option-title-active");
      $(".product-variant-container_carousel").removeClass(
        "products-option-title-active"
      );
      $(".product-variant-container_carousel")
        .eq(index)
        .addClass("products-option-title-active");
    }

    lIndex = index;
  });

  // --------------------------

  $(".product-card-new-variant").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    console.log($(this));
    let image = $(this).data("image");
    if (image) {
      $(this)
        .parents(".product-card-new")
        .find(".product-card-image")
        .find("img")
        .removeAttr("srcset");
      $(this)
        .parents(".product-card-new")
        .find(".product-card-image")
        .find("img")
        .attr("src", image);
    }
    $(this)
      .parents(".product-card-new")
      .find("a")
      .attr("href", $(this).data("url"));

    let price = $(this).data("price");
    console.log(price);
    let compare_at_price = $(this).data("compare_at_price");
    console.log(compare_at_price);
    if (price) {
      $(this)
        .parents(".product-card-new")
        .find(".product_switch__current-price")
        .text(price);
    }
    if (compare_at_price) {
      $(this)
        .parents(".product-card-new")
        .find(".product_switch__current-original_price")
        .text(compare_at_price);
    } else {
      $(this)
        .parents(".product-card-new")
        .find(".product_switch__current-original_price")
        .text("");
    }
  });
});

// endorsement home logo
document.addEventListener("DOMContentLoaded", function () {
  var endorsement_swiper2 = new Swiper(".endorseI .slitherSwiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    allowTouchMove: false,
  });
  var endorsement_swiper = new Swiper(".endorseII .Slitherarea", {
    spaceBetween: 10,
    slidesPerView: 7.5,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: ".endorseII .endorsement-button-next",
      prevEl: ".endorseII .endorsement-button-prev",
    },
    pagination: {
      el: ".endorseII .endorsement_pagination",
      clickable: true,
    },
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 3.5,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 7.5,
        spaceBetween: 40,
      },
    },
    on: {
      slideChangeTransitionStart: function () {
        var num = this.realIndex;
        endorsement_swiper2.slideTo(num);
      },
    },
  });
});

// endorsement home video
document.addEventListener("DOMContentLoaded", function () {
  var Eventswiper = new Swiper(".endorsement-events-swiper", {
    slidesPerView: "1.3",
    spaceBetween: 20,
    direction: "horizontal",
    speed: 1000,
    initialSlide: 2,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    parallax: true,
    loop: true,
    pagination: {
      el: ".endorsement-events-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".endorsement-events-next",
      prevEl: ".endorsement-events-prev",
    },
    watchOverflow: true,
  });
});

/* Feture popUp */
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".feature-pop-wrapper").forEach(wrapper => {

    const trigger = wrapper.querySelector(".feature-pop-heading");
    const modal = wrapper.querySelector(".feature-popup-modal");

    if (!trigger || !modal) return;

    trigger.addEventListener("click", function () {
      modal.classList.add("active");
    });

    trigger.setAttribute("tabindex", "0");
    trigger.setAttribute("role", "button");

    trigger.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        modal.classList.add("active");
      }
    });
    const closeBtn = wrapper.querySelector(".popup-close");
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        modal.classList.remove("active");
      });
    }

    const overlay = wrapper.querySelector(".feature-popup-overlay");
    if (overlay) {
      overlay.addEventListener("click", function () {
        modal.classList.remove("active");
      });
    }

  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document.querySelectorAll(".feature-popup-modal.active").forEach(modal => {
        modal.classList.remove("active");
      });
    }
  });

});
// product endorsement video
document.addEventListener("DOMContentLoaded", function () {
  var Eventswiper = new Swiper(".product-endorsement-vehicle_swiper", {
    spaceBetween: 25,
    breakpoints: {
      320: {
        slidesPerView: 1.4,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2.4,
        spaceBetween: 20,
      },
      912: {
        slidesPerView: 3.1,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3.4,
        spaceBetween: 20,
      },
      1380: {
        slidesPerView: 3.8,
        spaceBetween: 20,
      },
      1580: {
        slidesPerView: 4.5,
        spaceBetween: 30,
      },
    },
    pagination: {
      el: ".product-endorsement-events-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".product-endorsement-events-next",
      prevEl: ".product-endorsement-events-prev",
    },
    watchOverflow: true,
  });
});

// product-jump-floor
window.addEventListener("load", function () {
  $(".floor-jump_item").click(function (e) {
    // e.preventDefault();
    // let to_link = $(this).attr("href");
    $(this).addClass("active").siblings().removeClass("active");
    // let overTop = $("height-observer").innerHeight();
    // $(window)
    //   .stop(true, true)
    //   .scrollTop($(to_link).offset().top - overTop, 200);
  });
});


// handlebar option
document.addEventListener("DOMContentLoaded", function () {
  var HandOptionsQk = document.querySelectorAll(
    ".handlebar-Container-title-tag"
  );
  console.log(HandOptionsQk);
  var HandImagesQk = document.querySelectorAll(".handlebar-image-qk");
  console.log(HandImagesQk);
  var HandContents = document.querySelectorAll(".handlebar-tab-icon-describe");
  console.log(HandContents);

  HandOptionsQk[0].classList.add("active");
  HandImagesQk[0].classList.add("active");
  HandContents[0].classList.add("active");

  HandOptionsQk.forEach(function (tab, index) {
    tab.addEventListener("click", function () {
      HandImagesQk.forEach(function (content) {
        content.classList.remove("active");
      });
      HandOptionsQk.forEach(function (tab) {
        tab.classList.remove("active");
      });
      HandContents.forEach(function (content) {
        content.classList.remove("active");
      });

      HandImagesQk[index].classList.add("active");
      HandContents[index].classList.add("active");
      tab.classList.add("active");
    });
  });
});

// collection variant list
window.addEventListener("load", function () {
  $(".collection-card-new-variant").click(function () {
    console.log($(this));
    let image = $(this).data("image");
    if (image) {
      $(this)
        .parents(".collections-card-new")
        .find(".collection-product-card-image")
        .find("img")
        .removeAttr("srcset");
      $(this)
        .parents(".collections-card-new")
        .find(".collection-product-card-image")
        .find("img")
        .attr("src", image);
    }
    $(this)
      .parents(".collections-card-new")
      .find("a")
      .attr("href", $(this).data("url"));

    let price = $(this).data("price");
    console.log(price);
    let compare_at_price = $(this).data("compare_at_price");
    console.log(compare_at_price);
    if (price) {
      $(this)
        .parents(".collections-card-new")
        .find(".collection_eoo_switch__current-price")
        .text(price);
    }
    if (compare_at_price) {
      $(this)
        .parents(".collections-card-new")
        .find(".collection_switch__current-original_price")
        .text(compare_at_price);
    } else {
      $(this)
        .parents(".collections-card-new")
        .find(".collection_switch__current-original_price")
        .text("");
    }

    let selectedVariantId = $(this).data("id");
    $(this)
      .parents(".collections-card-new")
      .find("form")
      .find("input[name='id']")
      .val(selectedVariantId);
  });
});